/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartAreaStack = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M16.071 1.776 22 6.52V22H2V3.234l5.99 3.593zm-.143 9.447-7.917 4.95L4 13.766V20h16v-5.52zm0-7-7.917 4.95L4 6.766v4.667l3.99 2.394 8.081-5.05L20 11.918V7.48z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgChartAreaStack as ChartAreaStack };
